import axios, {AxiosError, AxiosPromise, AxiosRequestConfig} from 'axios'

let token = ''

const axiosInstance = axios.create({
    baseURL: (window as any).env.API_URL,
})

// Add a request interceptor
axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
    // Do something before request is sent
    config.headers.Authorization = 'Bearer ' + token
    return config
}, (error: any) => {
    // Do something with request error
    return Promise.reject(error)
})


export default {
    setToken(tk: string) {
        token = tk
    },
    debug: (p: any) => {
        return axiosInstance.post('debug', {
            packet: p
        }) as AxiosPromise<any[]>
    },
    log: (p: any) => {
        return axiosInstance.get('logs/' + p,) as AxiosPromise<any[]>
    },
    connections: () => {
        return axiosInstance.get('connections') as AxiosPromise<any[]>
    },
    devices: (serial: string) => {
        return {
            command: (cmd: string) => {
                return axiosInstance.post('devices/' + serial, {
                    command: cmd
                }) as AxiosPromise<any[]>
            }
        }
    },
    logs: (serial: string, dayStart: string, dayEnd: string) => {
        console.log(dayStart, dayEnd)
        return axiosInstance.get('connections/' + serial + '/logs', {
            params: {
                start: dayStart, end: dayEnd
            }
        }) as AxiosPromise<any[]>
    },
    sync: (serial: string) => {
        return axiosInstance.post('devices/' + serial + '/sync') as AxiosPromise<any[]>
    },
    key: (serial: string) => {
        return axiosInstance.post('devices/' + serial + '/virtual_key') as AxiosPromise<any[]>
    },
    rotateKey: (serial: string) => {
        return axiosInstance.post('devices/' + serial + '/rotate_key') as AxiosPromise<any[]>
    },
    logz: (serial: string) => {
        return axiosInstance.get('connections/' + serial + '/logz') as AxiosPromise<any[]>
    },
}
